<template>
  <div>
    <pills :filtro="filtro" />
    <div>
      <VueApexCharts
        v-if="available == true"
        type="line"
        :options="chartOptions"
        :series="series"
      ></VueApexCharts>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import DashboardProponenteService from "@/common/services/dashboards/dashboard_proponente.service.js";
import Pills from "./Pills";
import helpers from "@/common/utils/helpers";
export default {
  components: {
    VueApexCharts,
    Pills,
  },
  props: {
    empresas: {
      default: [],
    },
  },
  data: () => ({
    filtro: {},
    dados: [],
    chartOptions: {},
    axis: [],
    series: [],
    dadosCompletos: [],
    available: false,
  }),
  methods: {
    hideSeries(seriesIndex) {
      const newSeries = [...this.series];
      newSeries[seriesIndex].visible = false;
      this.series = newSeries;
    },
    buscar: function (empresaId, grupoNegocio = false, filtro = {}) {
      if (!empresaId && !grupoNegocio) return;
      this.filtro = filtro;
      DashboardProponenteService.graficoMovimentacaoFinanceira(
        empresaId,
        grupoNegocio,
        this.filtro
      ).then((response) => {
        this.dados = response.data.data;
        this.axis = this.calcularAxis();
        this.series = this.calcularSeries();
      });
    },
    calcularAxis: function () {
      let meses = this.dados.map((el) => {
        if (!el.pontos) return [];
        return el.pontos.map((el2) => {
          return {
            mes: el2.mes,
            ano: el2.ano,
            indiceMes: helpers.retornarIndiceMes(el2.mes),
          };
        });
      });
      let arrAxis = [];
      meses.forEach((el) => {
        el.forEach((el2) => {
          if (!arrAxis.find((arr) => arr.ano == el2.ano && arr.mes == el2.mes))
            arrAxis.push(el2);
        });
      });
      return arrAxis.sort((a, b) => {
        if (a.indiceMes == b.indiceMes && a.ano > b.ano) return 1;
        if (a.indiceMes == b.indiceMes && a.ano < b.ano) return -1;
        if (a.indiceMes > b.indiceMes && a.ano == b.ano) return 1;
        if (a.indiceMes < b.indiceMes && a.ano == b.ano) return -1;
        return 0;
      });
    },
    calcularSeries: function () {
      let dadosFormatado = this.dados
        .map((el) => {
          let dados = [];
          this.axis.forEach((axis) => {
            let ponto = el.pontos?.find(
              (p) => p.mes == axis.mes && p.ano == axis.ano
            );
            dados.push(
              ponto
                ? ponto
                : {
                    saldoPDSelic: 0,
                    saldoAcumulado2Anos: 0,
                    mes: axis.mes,
                    ano: axis.ano,
                  }
            );
          });
          return {
            empresa: el.empresa,
            pontos: dados.sort((a, b) => {
              let aIndice = helpers.retornarIndiceMes(a.mes);
              let bIndice = helpers.retornarIndiceMes(b.mes);

              if (aIndice == bIndice && a.ano > b.ano) return 1;
              if (aIndice == bIndice && a.ano < b.ano) return -1;
              if (aIndice > bIndice && a.ano == b.ano) return 1;
              if (aIndice < bIndice && a.ano == b.ano) return -1;
              return 0;
            }),
          };
        })
        .map((el) => {
          return [
            {
              name: `${el.empresa} - Saldo em conta P&D(com SELIC)`,
              data: el.pontos.map((el) => el.saldoPDSelic.toFixed(2)),
            },
            {
              name: `${el.empresa} - Montante acumulado nos últimos 2 anos`,
              data: el.pontos.map((el) => el.saldoAcumulado2Anos.toFixed(2)),
            },
          ];
        });

      let series = [];

      dadosFormatado.forEach((el) => {
        series.push(...el);
      });

      this.available = true;

      return series;
    },
  },
  watch: {
    dados: {
      handler() {
        this.chartOptions = {
          chart: {
            height: 350,
            type: "line",
            zoom: {
              enabled: false,
            },
          },

          tooltip: {
            custom: function ({ seriesIndex, dataPointIndex, w }) {
              let local = w.config.companiesValues[0].pontos[dataPointIndex];
              let value = "";
              const color = w.globals.colors[seriesIndex];
              const circle =
                '<span style="display:inline-block; width:10px; height:10px; border-radius:50%; background-color:' +
                color +
                '; margin-right:5px;"></span>';
              if (seriesIndex == 0) {
                for (let i = 0; i < local.empresas.length; i++) {
                  value += `<b-list-group-item class="ml-2">
                                        ${circle}
                                        ${
                                          local.empresas[i].empresa
                                        } R$ ${helpers.formatarValor(
                    local.empresas[i].saldoPDSelic
                  )}</b-list-group-item><br>`;
                }
              } else {
                for (let i = 0; i < local.empresas.length; i++) {
                  value += `<b-list-group-item class="ml-2">
                                       ${circle}
                                       ${
                                         local.empresas[i].empresa
                                       } R$ ${helpers.formatarValor(
                    local.empresas[i].saldoAcumulado2Anos
                  )}</b-list-group-item><br>`;
                }
              }
              return "<b-list-group>" + value + "</b-list-group>";
            },
          },
          dataLabels: {
            enabled: false,
            textAnchor: "middle",
            formatter: function (val) {
              return helpers.formatarValor(val);
            },
          },
          stroke: {
            curve: "smooth",
          },
          companiesValues: this.dados,
          markers: {
            size: 7,
          },
          xaxis: {
            categories: this.axis.map((el) => {
              return `${el.mes == "Marco" ? "Março" : el.mes}/${el.ano}`;
            }),
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return helpers.formatarValor(val);
              },
            },
          },
        };
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
  },
};
</script>
<style lang="">
</style>